import { SUPPLIERS, SUPPLIERS_SEARCH } from "../../types/SuppliersType";
import axios from "axios";

const getSuppliers = (data) => {
	return {
		type: SUPPLIERS,
		payload: data,
	};
};

const getSuppliersSearch = (data) => {
	return {
		type: SUPPLIERS_SEARCH,
		payload: data,
	};
};

export const loadSuppliers = ({ page, limit, status }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(
				`supplier?status=${status}&page=${page}&count=${limit}`
			);
			//dispatching data
			dispatch(getSuppliers(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};

export const loadAllSuppliersForSearch = ({ status }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			console.log("Loading all suppliers for search with status:", status);
			const url = `supplier?query=all&status=${status}`;
			console.log("API URL:", url);
			const { data } = await axios.get(url);
			console.log("Search suppliers loaded:", data.length);
			console.log("First supplier:", data[0]);
			//dispatching data
			dispatch(getSuppliersSearch(data));
		} catch (error) {
			console.log("Error loading search suppliers:", error.message);
			console.log("Error response:", error.response?.data);
		}
	};
};
